// extracted by mini-css-extract-plugin
export default {"Label":"AddPost_Label__3PGre","Image":"AddPost_Image__RJ7Gv"};